import Vue from "vue";
import wrap from "@vue/web-component-wrapper";

const BioSpaceActivities = () =>
  import(
    "@/components/biologicals/ProjectActivities/SpaceProjectActivities.vue"
  );
const BioSpaceActivitiesWebComponent = wrap(Vue, BioSpaceActivities);
window.customElements.define(
  "bio-space-activities-wc",
  BioSpaceActivitiesWebComponent,
);
